import { render } from "./toggle.vue?vue&type=template&id=6880d7f6&scoped=true"
import script from "./toggle.vue?vue&type=script&lang=js"
export * from "./toggle.vue?vue&type=script&lang=js"

import "./toggle.vue?vue&type=style&index=0&id=6880d7f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6880d7f6"

export default script